export default __webpack_public_path__ + "static/logo-7dbebfa7f413e69f1d82b45c58391363.png";